/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EquipmentFitmentSpecification
 */
export interface EquipmentFitmentSpecification {
    /**
     * 
     * @type {string}
     * @memberof EquipmentFitmentSpecification
     */
    externalId?: string;
    /**
     * 
     * @type {number}
     * @memberof EquipmentFitmentSpecification
     */
    partId?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentFitmentSpecification
     */
    position?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentFitmentSpecification
     */
    locationId?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentFitmentSpecification
     */
    secondaryLocationId?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentFitmentSpecification
     */
    group?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EquipmentFitmentSpecification
     */
    isNewSpec?: boolean | null;
}

/**
 * Check if a given object implements the EquipmentFitmentSpecification interface.
 */
export function instanceOfEquipmentFitmentSpecification(value: object): value is EquipmentFitmentSpecification {
    return true;
}

export function EquipmentFitmentSpecificationFromJSON(json: any): EquipmentFitmentSpecification {
    return EquipmentFitmentSpecificationFromJSONTyped(json, false);
}

export function EquipmentFitmentSpecificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentFitmentSpecification {
    if (json == null) {
        return json;
    }
    return {
        
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'partId': json['partId'] == null ? undefined : json['partId'],
        'position': json['position'] == null ? undefined : json['position'],
        'locationId': json['locationId'] == null ? undefined : json['locationId'],
        'secondaryLocationId': json['secondaryLocationId'] == null ? undefined : json['secondaryLocationId'],
        'group': json['group'] == null ? undefined : json['group'],
        'isNewSpec': json['isNewSpec'] == null ? undefined : json['isNewSpec'],
    };
}

export function EquipmentFitmentSpecificationToJSON(json: any): EquipmentFitmentSpecification {
    return EquipmentFitmentSpecificationToJSONTyped(json, false);
}

export function EquipmentFitmentSpecificationToJSONTyped(value?: EquipmentFitmentSpecification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalId': value['externalId'],
        'partId': value['partId'],
        'position': value['position'],
        'locationId': value['locationId'],
        'secondaryLocationId': value['secondaryLocationId'],
        'group': value['group'],
        'isNewSpec': value['isNewSpec'],
    };
}

